export default __webpack_public_path__ + "static/media/nucleo-icons.ec16bc4c.woff2";